import React from "react";
import { ExpandedState } from "@tanstack/react-table";
import { FiltersTypes } from "@common/types/filters/general";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { CollapseAllButton } from "@design-system/ViewTable/CollapseAllButton";
import { ViewTableHandle } from "@design-system/ViewTable/ViewTable";
import { YearFilter } from "@components/settings/YearFilter/YearFilter";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { FiltersChangeFn } from "@components/pageHeader/filters/lib";

interface Props {
    expanded: ExpandedState;
    tableRef: React.RefObject<ViewTableHandle | null>;
    search: string;
    setSearch: (search: string) => void;
    filters: Pick<FiltersTypes, "start" | "end" | "entityIds">;
    onFiltersChange: FiltersChangeFn;
}

export const DocumentCategoriesHeader = ({
    expanded,
    tableRef,
    search,
    setSearch,
    filters,
    onFiltersChange,
}: Readonly<Props>) => (
    <TablePageHeader
        filters={filters}
        onFiltersChange={onFiltersChange}
        search={search}
        onSearchChange={(value) => {
            setSearch(value ?? "");
        }}
        availableFilters={[]}
        hideOverlay
        hideClearButton
        isFullPage
    >
        <YearFilter filters={filters} onChange={onFiltersChange} />
        <EntityFilterCombobox filters={filters} onChange={onFiltersChange} />
        <CollapseAllButton expanded={expanded} tableRef={tableRef} />
    </TablePageHeader>
);
